import { AxiosResponse } from 'axios';
import { client } from './axiosClient';

export const postNpsAskMeLAter = async () => {
  const res = await client.post('/nps/ask-me-later', {});
  return res.data;
};

interface NpsFeedbackInput {
  score: number;
  comment: string;
  company_id: string;
}

export const postNpsFeedback = async (
  company_id: string,
  score: number,
  comment: string = ''
) => {
  const res = await client.post<
    NpsFeedbackInput,
    AxiosResponse<{
      id: number;
    }>
  >('/nps', { score, comment, company_id });
  return res.data;
};

export const postNpsFeedbackComment = async (
  company_id: string,
  id: number,
  comment: string
) => {
  const res = await client.post<
    Omit<NpsFeedbackInput, 'score'>,
    AxiosResponse<null>
  >(`/nps/${id}/comment`, { comment, company_id });
  return res.data;
};
